import React from "react";
import PropTypes from "prop-types";
import RenderAssumption from "../../components/RenderAssumption/RenderAssumption";
import ChargingRangeGraph from "../CostsCharts/ChargingRangeGraph";
import { FormattedMessage } from "react-intl";

const SpeedOfCharge = ({ cars, title }) => {
  if (!cars || cars.length === 0) return null;

  const level2ChargingSpeed = {
    title: "Level 2 Charger Speed",
    valueAsFormatted: "7.7 kW",
  };

  const fastChargingSpeed = {
    title: "Fast Charging Speed",
    valueAsFormatted: "50 kW",
  };

  return (
    <section className="container">
      <div className="row">
        <div className="col-md-4 col-lg-4">
          <div className="col-sm-12 ">
            <p className="h1 bottom-margin" style={{fontSize: "36px", fontWeight: "700"}}>Electric Range</p>
          </div>
          <div className="input-well d-none d-md-block">
            <p className="RenderItemTitle" style={{ marginBottom: 20, textAlign: "left" }}>
              <FormattedMessage
                id="graph.assumptions"
                defaultMessage="Assumptions"
                description="Assumptions"
              />
            </p>
            <p className="RenderItemTitle" style={{ marginBottom: 10, textAlign: "left", textTransform: "none" }}>
              <FormattedMessage
                id="graph.assumptionsSubTitle"
                defaultMessage="Range based on EPA estimates."
                description="Range based on EPA estimates."
              />
            </p>
            <RenderAssumption assumption={level2ChargingSpeed} color={"#EB1700"}/>
            <RenderAssumption assumption={fastChargingSpeed} color={"#EB1700"}/>
          </div>
        </div>
        <div
          id="costs-chart-areas"
          aria-live="polite"
          aria-atomic="true"
          role="region"
          style={{ position: "absolute", top: "-9999px" }}
        >
          <span>
            <FormattedMessage
              id="results.updated"
              defaultMessage="Results have been updated as of "
              description="Results have been updated as of "
            />
            {new Date().toLocaleString()}.
          </span>
        </div>
        <div className="col-md-8 col-lg-8">
          <ChargingRangeGraph cars={cars} chargerLevel={"dc_fast_charger"} />
          <br />
          <ChargingRangeGraph cars={cars} chargerLevel={"level_2"} />
        </div>
      </div>
    </section>
  );
};

export default SpeedOfCharge;

SpeedOfCharge.propTypes = {
  cars: PropTypes.array,
  title: PropTypes.string,
};
